import { SVGProps } from 'react';

const IndentIncrease = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12H11m10 6H11M21 6H11M3 8l4 4-4 4"
    />
  </svg>
);
export default IndentIncrease;
